export enum PAYMENT_TYPE {
  PAYMENT_FIRST = 1,
  CREDIT_TERMS = 2
};
